/**
 * Masks the last 10 digits of a phone number with dashes.
 * If the last 10 digits phone number contains non-digit characters, it returns the original phone number.
 *
 * @param phoneNumber - The phone number to be masked.
 * @returns The masked phone number or the original phone number if it contains non-digit characters.
 */
const maskPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return '';
  }
  const lastTenDigits = phoneNumber.slice(-10);

  if (!lastTenDigits.match(/^\d+$/)) {
    return phoneNumber;
  }

  return lastTenDigits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export default maskPhoneNumber;
